import { render, staticRenderFns } from "./btn-back.vue?vue&type=template&id=3f8bd712"
import script from "./btn-back.vue?vue&type=script&lang=js"
export * from "./btn-back.vue?vue&type=script&lang=js"
import style0 from "./btn-back.vue?vue&type=style&index=0&id=3f8bd712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports